import { useMemo } from 'react';

import { useMultipleSelect } from 'components/modules/Insurance/hooks/useMultipleSelect';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { selectDriver } from 'store/insuranceAnketa/selectors';

import {
  HEADER_STORE_FALLBACK,
  HEADER_STORE_MAP,
  HEADER_STORE_TRANSFORM,
} from '../DriverCard.constants';
import { generateDescription } from '../DriverCard.helpers';

export const useHeader = ({ id }) => {
  const { values } = useMultipleSelect({
    fallback: HEADER_STORE_FALLBACK,
    map: HEADER_STORE_MAP,
    selector: selectDriver(id),
    transform: HEADER_STORE_TRANSFORM,
  });

  const { [DRIVER_FIELDS.FULL_NAME]: title } = values;
  const valuesDependencies = Object.values(values);

  const description = useMemo(
    () => {
      return generateDescription(values);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    valuesDependencies
  );

  return { description, title };
};
